module.exports = __webpack_public_path__ + "img/T5-A-rc_12.0fa70cdf.png";